/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Rtl_LabelInputs */

const en_new_project_rtl_label = /** @type {(inputs: New_Project_Rtl_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right-To-Left`)
};

const fr_new_project_rtl_label = /** @type {(inputs: New_Project_Rtl_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Droite a gauche`)
};

const de_new_project_rtl_label = /** @type {(inputs: New_Project_Rtl_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von rechts nach links`)
};

const it_new_project_rtl_label = /** @type {(inputs: New_Project_Rtl_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da destra a sinistra`)
};

const ru_new_project_rtl_label = /** @type {(inputs: New_Project_Rtl_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Справа налево`)
};

const es_new_project_rtl_label = /** @type {(inputs: New_Project_Rtl_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De derecha a izquierda`)
};

const zh_cn2_new_project_rtl_label = /** @type {(inputs: New_Project_Rtl_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从右到左`)
};

const ja_new_project_rtl_label = /** @type {(inputs: New_Project_Rtl_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`右から左へ`)
};

const hi_new_project_rtl_label = /** @type {(inputs: New_Project_Rtl_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दाएँ से बाएँ`)
};

const pt_pt2_new_project_rtl_label = /** @type {(inputs: New_Project_Rtl_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da direita para a esquerda`)
};

/**
* | output |
* | --- |
* | "Right-To-Left" |
*
* @param {New_Project_Rtl_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_rtl_label = /** @type {((inputs?: New_Project_Rtl_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Rtl_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_rtl_label(inputs)
	if (locale === "de") return de_new_project_rtl_label(inputs)
	if (locale === "it") return it_new_project_rtl_label(inputs)
	if (locale === "ru") return ru_new_project_rtl_label(inputs)
	if (locale === "es") return es_new_project_rtl_label(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_rtl_label(inputs)
	if (locale === "ja") return ja_new_project_rtl_label(inputs)
	if (locale === "hi") return hi_new_project_rtl_label(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_rtl_label(inputs)
	return en_new_project_rtl_label(inputs)
});